import React from "react";
import type { ApiAbout } from "../types";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/utils/date";
import MobileListWrapper from "@/components/mobile-list-wrapper";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

interface ListContentProps {
  data: ApiAbout[];
  isLoading: boolean;
  className?: string;
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  emptyListComponent: React.ReactElement;
}

const ListContent = ({
  data,
  isLoading,
  className,
  page,
  pageCount,
  onPageChange,
  emptyListComponent,
}: ListContentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <MobileListWrapper
      data={data}
      isLoading={isLoading}
      className={className}
      page={page}
      pageCount={pageCount}
      onPageChange={onPageChange}
      emptyListComponent={emptyListComponent}
      onItemClick={(about) => navigate(ROUTES.ABOUT_DETAILS(about.id))}
      renderItem={(about) => (
        <>
          <div className="flex items-center justify-between">
            <h3 className="font-semibold">{about.title}</h3>
          </div>
          <div className="mt-1 mb-2">
            <p className="text-sm text-gray-500">{about.description}</p>
          </div>
          <div className="flex items-center justify-between">
            <Badge variant="secondary">
              {t(`modules.about.types.${about.icon_name}`)}
            </Badge>
            <p className="text-sm text-gray-500 shrink-0">
              {formatDate(about.created_at)}
            </p>
          </div>
        </>
      )}
    />
  );
};

export default ListContent;
